/* nodename-css:
 *
 * Many times I wished the node name would be
 * accessible from the body down, so I could
 * create CSS rules based on the nodename.
 *
 *
 * Author: Tim Bauwens
 * Copyright 2022 xxllnc
 *
 */

((doc, $) => {
  $(doc).on("bb:finalHandleData", (e, data) => {
    if (data && data.groups && data.groups.length) {
      try {
        let currentGroup = data.groups[data.groups.length - 1];
        let nodename = currentGroup.name;
        doc.body.dataset.node = nodename;
      } catch (err) {
        window.console && window.console.warn(err);
      }
    }
  });
})(document, jQuery);
